<template>
  <div>
    <div class="con-tab-ejemplo">
      <div class="vx-row">
        <div class="vx-col w-full vx-coll-fixed-hight">
          <vs-table :data="paymentRounds">

            <template slot="thead">
              <vs-th class="w-1/6">{{ $t('sections.accounting.dataForm.tablePaymentRound.no') }}</vs-th>
              <vs-th class="w-1/6">{{ $t('sections.accounting.dataForm.tablePaymentRound.date') }}</vs-th>
              <vs-th class="w-1/6">{{ $t('sections.accounting.dataForm.tablePaymentRound.type') }}</vs-th>
              <vs-th class="w-1/6">{{ $t('sections.accounting.dataForm.tablePaymentRound.amount') }}</vs-th>
              <vs-th class="w-1/6">ดอกเบี้ย</vs-th>
              <vs-th class="w-1/6">ยอดค้างชำระ</vs-th>
              <vs-th class="w-1/12"></vs-th>
            </template>
            <template slot-scope="{data}" >
              <vs-tr :key="index" v-for="(res, index) in data" :state="isPaymentRoundExtraState(res)">
                <vs-td :data="res.paymentRoundSeq">
                  {{ res.paymentRoundSeq }}
                </vs-td>
                <vs-td :data="res.paymentRoundDate">
                  {{ res.paymentRoundDate | convYYYYMMDDToDDMMYYYY}}
                </vs-td>
                <vs-td :data="res.paymentRoundType">
                  {{ res.paymentRoundType | paymentRoundType }}
                  <small v-if="(res.paymentRoundExtra)"><u>{{ 'รอบพิเศษ' }}</u></small>
                </vs-td>
                <vs-td :data="res.paymentRoundAmount">
                  {{ res.paymentRoundAmount | numberFormat }} <small>({{ res.paymentRoundAmountRestructuring | numberFormat }})</small>
                </vs-td>
                <vs-td :data="paymentRoundInterest(res)">
                  {{ paymentRoundInterest(res) }}
                </vs-td>
                <vs-td :data="res.paymentRoundBalance">
                  {{ res.paymentRoundBalance | numberFormat }}
                </vs-td>
                <vs-td>
                  <vs-button color="danger" type="flat" icon-pack="feather" icon="icon-delete" @click="delPaymentRound(res.id)" v-show="!isHideDelPaymentRound(res)"></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'
const { mapActions: mapAccountingActions, mapState: mapAccountingState} = createNamespacedHelpers('Accounting');

export default {
  props: ['manage'],
  computed:{
    ...mapAccountingState([
      'status',
      'contract',
      'paymentRounds',
    ])
  },
  methods: {
    ...mapAccountingActions([
      'deletePaymentRounds',
    ]),
    isPaymentRoundExtraState(res){
      let isState = null
      if(res.paymentRoundExtra){
        isState = "warning"
      }
      return isState
    },
    paymentRoundInterest(res){
      const vm = this
      let paymentRoundInterest = 0
      if( res.paymentRoundType !== "InterestFixed" ){
        paymentRoundInterest = vm.$options.filters.numberFormat(res.paymentRoundInterest)
      }else{
        paymentRoundInterest = vm.$options.filters.numberFormat(res.paymentRoundInterestFixed)
      }
      return paymentRoundInterest
    },
    async delPaymentRound (id) {
      const vm = this
      const { deletePaymentRounds } = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: vm.$t('notification.confirm-delete-title'),
        text: vm.$t('notification.confirm-delete-message'),
        accept: async () => {
          await deletePaymentRounds({
            form: {
              id
            },
            vm: vm
          })
        }
      })
    },
    isHideDelPaymentRound (res){
      const { transactionCount, paymentRoundSeq, paymentRoundBalance, paymentRoundInterest } = res
      return !(transactionCount === 0 && paymentRoundSeq > 1 && (paymentRoundBalance <= 0 && paymentRoundInterest <= 0) && this.manage);
    },
  },
}
</script>

<style scoped>
  .vx-coll-fixed-hight{
    display:block;
    width:100%;
    height:400px;
    overflow: auto;
  }
</style>
